import(/* webpackMode: "eager" */ "/home/runner/_work/lt-telia-web-apps/lt-telia-web-apps/apps/EShop/app/global-error.tsx");
